import { UseFetchHookOutput } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { useApi, useFetch } from '@hooks';
import { useSaveServiceResponse } from '@store';
import {
	AccountGenerateCaptchaInputDto,
	AccountGenerateCaptchaOutputDto,
	AccountGenerateCaptchaOutputDtoSingleOutputMessage,
} from '@types';

export const useFetchAccountGenerateCaptcha = (): UseFetchHookOutput<
	AccountGenerateCaptchaInputDto,
	AccountGenerateCaptchaOutputDto
> => {
	const { accountGenerateCaptcha: fetchAccountGenerateCaptcha } = useApi();
	const saveServiceResponse = useSaveServiceResponse();

	return useFetch<AccountGenerateCaptchaInputDto, AccountGenerateCaptchaOutputDto>({
		input: {
			fetchFn: fetchAccountGenerateCaptcha,
			onSuccess: (res: AccountGenerateCaptchaOutputDtoSingleOutputMessage) => {
				saveServiceResponse({ accountGenerateCaptcha: res.data });
			},
		},
		requestName: 'account/generateCaptcha',
	});
};
